import * as React from 'react';
export const ESSvg = React.forwardRef(function ESSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 5h16v6H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        d: 'M15 11V5h1v6h-1ZM0 5h1v6H0V5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 5V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H0Zm14 9H2a2 2 0 0 1-2-2v-1h16v1a2 2 0 0 1-2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M4 6h2v2H4z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F79A59',
        d: 'M4 10.5a2 2 0 0 1-2-2V8h2v2.5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M4 10.5V8h2v.5a2 2 0 0 1-2 2ZM2 6h2v2H2V6Z',
      }),
    ),
  );
});
ESSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var ES = {
  category: 'flag',
  colorable: false,
  name: 'ES',
  svg: ESSvg,
};
